document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.wp-block-cb-carousel');

    carousels.forEach(function (carousel) {
        if (carousel.classList.contains('slick-initialized')) {
            jQuery(carousel).slick('unslick');
        }

        const slickSettings = JSON.parse(carousel.getAttribute('data-slick'));

        // Adiciona configurações responsivas
        slickSettings.responsive = [
            {
                breakpoint: 768, // Configurações para telas com largura menor ou igual a 768px
                settings: {
                    centerMode: true,
                    centerPadding: '16px',
                    slidesToShow: 1, // Exemplo: mostra 1 slide
                },
            },
            {
                breakpoint: 480, // Configurações para telas com largura menor ou igual a 480px
                settings: {
                    centerMode: true,
                    centerPadding: '30px',
                    slidesToShow: 1, // Exemplo: mostra 1 slide

                },
            },
        ];

        carousel.setAttribute('data-slick', JSON.stringify(slickSettings));
		jQuery(carousel).slick(slickSettings);

		jQuery(carousel).slick('slickSetOption', {
			cssEase: 'linear',
		}, true);

		if (carousel.classList.contains('assembleia-logos')) {
            jQuery(carousel).slick('slickSetOption', {
				speed: 5000,
				cssEase: 'linear',
				variableWidth: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
						}
					}
				]
			}, true)
        }

		if (carousel.classList.contains('iniciativas')) {
            jQuery(carousel).slick('slickSetOption', {
				responsive: [
					{
						breakpoint: 1440,
						settings: {
							slidesToShow: 4,
						}
					}
				]
			}, true)
        }

    });
});





